import * as React from 'react';
// import Typography from '@mui/material/Typography';

export default function FaqItem(props) {
    return (
        <div className="faq-item">
            <h6
                // variant="h6"
                className="faq-item-question"
            >
                {props.item.question}
            </h6>
            <span
                // variant="body2"
                className="faq-item-answer"
            >
                {props.item.answer}
            </span>
        </div>
    );
}